import React from 'react';
import FilesConfigProvider from '../data/filesconfig-hooks';
import Files from '../components/Files';

function FilesApp(props) {

    const templateContainerID = props.templateContainerID;
    const configContainerID = props.configContainerID;
    const addButtonID = props.addButtonID;

    return (
        <div className="itinerarydetails">
            <FilesConfigProvider templateContainerID={templateContainerID} configContainerID={configContainerID}>
                <Files addButtonID={addButtonID}></Files>
            </FilesConfigProvider>
        </div>
    );
}

export default FilesApp;